import React from "react";

const MarkdownWrapper = ({ children }) => {
  if (!children) return null;

  // Função para converter texto com formatação Markdown simples
  const formatText = (text) => {
    if (typeof text !== 'string') return text;

    // Escapar caracteres HTML para segurança
    let escapedText = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // Substituir quebras de linha por <br>
    let formattedText = escapedText.replace(/\n/g, '<br>');

    // Negrito: *texto* ou **texto**
    formattedText = formattedText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    formattedText = formattedText.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

    // Itálico: _texto_
    formattedText = formattedText.replace(/_(.*?)_/g, '<em>$1</em>');

    // Tachado: ~texto~
    formattedText = formattedText.replace(/~(.*?)~/g, '<s>$1</s>');

    // Monospace: `texto`
    formattedText = formattedText.replace(/`(.*?)`/g, '<code>$1</code>');

    // Links: [texto](url)
    formattedText = formattedText.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

    return formattedText;
  };

  // Se for uma string, formatar o texto
  if (typeof children === 'string') {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: formatText(children) }}
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
      />
    );
  }

  // Se for JSX, apenas retornar o conteúdo
  return <div>{children}</div>;
};

export default MarkdownWrapper;